import { DEFAULT_SUB_BOTS } from "basis/constants";
import { MutationTree } from "vuex/types";

const state = () => ({
  bots: DEFAULT_SUB_BOTS
});

export type BotState = ReturnType<typeof state>;

const mutations: MutationTree<BotState> = {
  TOGGLE_BOT(state, id) {
    const added = state.bots.includes(id);
    if (added) {
      const index = state.bots.findIndex(b => b === id);
      state.bots.splice(index, 1);
    } else {
      state.bots.push(id);
    }
  }
};

export default {
  namespaced: true,
  state,
  mutations
};
